import { render } from "./quote_setup.vue?vue&type=template&id=b73f9a0a"
import script from "./quote_setup.vue?vue&type=script&lang=js"
export * from "./quote_setup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__